module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "splash"
  }, [_c('div', {
    staticClass: "filter"
  }, [_c('div', {
    staticClass: "section-header"
  }, [_c('el-row', [_c('span', [_vm._v("Dashboard")])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "filter-section"
  }, [_c('label', [_c('span', {
    staticClass: "filter-title-label"
  }, [_vm._v("Date Range")]), _vm._v(" "), _c('el-date-picker', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterDateRange),
      expression: "filterDateRange"
    }],
    staticClass: "filter-section-input",
    attrs: {
      "label": "Date Range",
      "type": "daterange",
      "placeholder": "Date Range",
      "format": "dd-MM-yyyy",
      "range-separator": " ~ ",
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "small": ""
    },
    domProps: {
      "value": (_vm.filterDateRange)
    },
    on: {
      "change": _vm.dateRangeUpdated,
      "input": function($event) {
        _vm.filterDateRange = $event
      }
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("Http://")])], 2)], 1), _vm._v(" "), _c('label', [_c('span', {
    staticClass: "filter-title-label"
  }, [_vm._v("Unit")]), _vm._v(" "), _c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedUnit),
      expression: "selectedUnit"
    }],
    staticClass: "filter-section-input",
    attrs: {
      "placeholder": "Unit"
    },
    domProps: {
      "value": (_vm.selectedUnit)
    },
    on: {
      "change": _vm.unitUpdated,
      "input": function($event) {
        _vm.selectedUnit = $event
      }
    }
  }, [_c('el-option', {
    attrs: {
      "label": "All Units",
      "value": 0
    }
  }), _vm._v(" "), _vm._l((_vm.units), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.displayText,
        "value": item.id
      }
    }, [_c('span', {
      staticStyle: {
        "float": "left"
      }
    }, [_vm._v(_vm._s(item.displayText))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right",
        "color": "#8492a6",
        "font-size": "13px"
      }
    }, [_vm._v(_vm._s(item.value))])])
  })], 2)], 1), _vm._v(" "), _c('label', [_c('span', {
    staticClass: "filter-title-label"
  }, [_vm._v("Infection Site")]), _vm._v(" "), _c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filteredSite),
      expression: "filteredSite"
    }],
    staticClass: "filter-section-input",
    attrs: {
      "placeholder": "Select Infection Site"
    },
    domProps: {
      "value": (_vm.filteredSite)
    },
    on: {
      "change": _vm.symptomTypeUpdated,
      "input": function($event) {
        _vm.filteredSite = $event
      }
    }
  }, _vm._l((_vm.symptomTypes), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('label', [_c('span', {
    staticClass: "filter-title-label"
  }, [_vm._v("Origin")]), _vm._v(" "), _c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedOrigin),
      expression: "selectedOrigin"
    }],
    staticClass: "filter-section-input",
    attrs: {
      "placeholder": "Origin"
    },
    domProps: {
      "value": (_vm.selectedOrigin)
    },
    on: {
      "change": _vm.originUpdated,
      "input": function($event) {
        _vm.selectedOrigin = $event
      }
    }
  }, _vm._l((_vm.origins), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('label', [_c('span', {
    staticClass: "filter-title-label"
  }, [_vm._v("Status")]), _vm._v(" "), _c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedStatus),
      expression: "selectedStatus"
    }],
    staticClass: "filter-section-input",
    attrs: {
      "placeholder": "Status"
    },
    domProps: {
      "value": (_vm.selectedStatus)
    },
    on: {
      "change": _vm.confirmStatusUpdated,
      "input": function($event) {
        _vm.selectedStatus = $event
      }
    }
  }, [_c('el-option', {
    attrs: {
      "label": "All",
      "value": 0
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Confirmed",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Suspected",
      "value": 2
    }
  })], 1)], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "section-header"
  }, [_c('el-row', [_vm._v("\n      Case Frequency\n      "), _c('div', {
    staticClass: "graph-filter"
  }, [_c('el-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.graphPeriodFilter),
      expression: "graphPeriodFilter"
    }],
    attrs: {
      "size": "small"
    },
    domProps: {
      "value": (_vm.graphPeriodFilter)
    },
    on: {
      "input": function($event) {
        _vm.graphPeriodFilter = $event
      }
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "By Year"
    }
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "By Quarter"
    }
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "By Month"
    }
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "By Week"
    }
  })], 1), _vm._v(" "), _c('el-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.graphDisplayFilter),
      expression: "graphDisplayFilter"
    }],
    attrs: {
      "size": "small"
    },
    domProps: {
      "value": (_vm.graphDisplayFilter)
    },
    on: {
      "input": function($event) {
        _vm.graphDisplayFilter = $event
      }
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "By Unit"
    }
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "By Infection Site"
    }
  })], 1)], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "graph"
  }, [_c('inf-case-graph', {
    attrs: {
      "range": _vm.filterDateRange,
      "period": _vm.filterPeriods,
      "sites": _vm.filterSymptomTypes,
      "origin": _vm.filterOrigin,
      "confirmed": _vm.filterConfirmStatus,
      "config": _vm.graphConfig,
      "mode": _vm.graphMode,
      "unitId": _vm.selectedUnit
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "section-header"
  }, [_c('el-row', [_c('span', [_vm._v("Case Detail")]), _vm._v(" "), _c('div', {
    staticClass: "case-filter"
  }, [_c('el-button', {
    staticClass: "case-export-button",
    attrs: {
      "plain": true,
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        _vm.exportExcel()
      }
    }
  }, [_vm._v("Export Data")]), _vm._v(" "), _c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.symptomDetailPageSize),
      expression: "symptomDetailPageSize"
    }],
    staticClass: "case-page-size-filter",
    attrs: {
      "size": "mini",
      "placeholder": "Choose tags for your article"
    },
    domProps: {
      "value": (_vm.symptomDetailPageSize)
    },
    on: {
      "input": function($event) {
        _vm.symptomDetailPageSize = $event
      }
    }
  }, _vm._l((_vm.symptomDetailPageSizeOptions), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  })), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "small": "",
      "layout": "prev, pager, next",
      "current-page": _vm.symptomDetailPage,
      "page-count": _vm.symptomDetailPageTotal
    },
    on: {
      "current-change": _vm.reloadPage
    }
  })], 1)])], 1), _vm._v(" "), (_vm.selectedCase) ? _c('el-dialog', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dialogFormVisible),
      expression: "dialogFormVisible"
    }],
    attrs: {
      "title": "Case Detail"
    },
    domProps: {
      "value": (_vm.dialogFormVisible)
    },
    on: {
      "input": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('surveillance-case-detail', {
    attrs: {
      "caseData": _vm.selectedCase,
      "clientData": _vm.clients[_vm.selectedCase.clientId],
      "origins": _vm.origins,
      "organisms": _vm.organisms,
      "treatments": _vm.treatments
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.saveSymtomDetail(_vm.selectedCase)
      }
    }
  }, [_vm._v("Update")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false;
        this.selectedCase = null
      }
    }
  }, [_vm._v("Close")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.loadingData),
      expression: "loadingData",
      modifiers: {
        "body": true
      }
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.cases,
      "default-sort": {
        prop: 'onSetDate',
        order: 'descending'
      }
    },
    on: {
      "row-click": _vm.selectedRow
    }
  }, [_c('el-table-column', {
    attrs: {
      "fixed": "",
      "label": " ",
      "width": "100"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('div', {
          staticStyle: {
            "padding": "0.5em"
          }
        }, [(_vm.clients[scope.row.clientId]) ? _c('div', {
          staticClass: "profile-row-photo",
          attrs: {
            "span": 4
          }
        }, [_c('img', {
          attrs: {
            "src": _vm.photosUrl(scope.row.clientId)
          }
        })]) : _c('div', {
          staticClass: "profile-row-photo",
          attrs: {
            "span": 4
          }
        }, [_c('img', {
          attrs: {
            "src": require("assets/user.png")
          }
        })])])]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "Name",
      "sortable": "",
      "fixed": "",
      "width": "180"
    },
    scopedSlots: {
      default: function(scope) {
        return [(_vm.clients[scope.row.clientId]) ? _c('span', [_vm._v(_vm._s(_vm.clientName(scope.row))), _c('br'), _vm._v("(" + _vm._s(_vm.clients[scope.row.clientId].patientId) + ")")]) : _c('span', [_vm._v(_vm._s(scope.row.name))])]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Infection Site",
      "width": "140"
    },
    scopedSlots: {
      default: function(scope) {
        return [(scope.row.symptomType === 'GI') ? _c('span', {
          staticClass: "color-code-label-0"
        }) : (scope.row.symptomType === 'UTI') ? _c('span', {
          staticClass: "color-code-label-2"
        }) : _c('span', {
          staticClass: "color-code-label-1"
        }), _vm._v("\n        " + _vm._s(scope.row.symptomType) + "\n      ")]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Status",
      "width": "80"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('img', {
          staticClass: "symptom-status-image",
          attrs: {
            "src": _vm.statusImage(scope.row)
          }
        })]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Symptoms",
      "min-width": "160"
    },
    scopedSlots: {
      default: function(scope) {
        return _vm._l((scope.row.symptoms), function(d) {
          return _c('el-tag', {
            key: d.id,
            attrs: {
              "type": _vm.tagType(d)
            }
          }, [_vm._v(_vm._s(d.displayText))])
        })
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Precautions",
      "min-width": "160"
    },
    scopedSlots: {
      default: function(scope) {
        return [(_vm.clients[scope.row.clientId]) ? _c('div', _vm._l((_vm.clients[scope.row.clientId].precautionDetails), function(d) {
          return _c('el-tag', [_vm._v(_vm._s(_vm.precautionById(d.precautionId)))])
        })) : _vm._e()]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Location",
      "width": "160"
    },
    scopedSlots: {
      default: function(scope) {
        return [_vm._v("\n        " + _vm._s(_vm.unitById(scope.row.unitId)) + " / " + _vm._s(_vm.beds[scope.row.bedId]) + "\n      ")]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Origin",
      "width": "200"
    },
    scopedSlots: {
      default: function(scope) {
        return [_vm._v("\n        " + _vm._s(_vm.originById(scope.row.origin)) + "\n      ")]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Organism",
      "width": "220"
    },
    scopedSlots: {
      default: function(scope) {
        return [_vm._v("\n        " + _vm._s(_vm.organismById(scope.row.organismId)) + "\n      ")]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Treatment",
      "width": "220"
    },
    scopedSlots: {
      default: function(scope) {
        return [_vm._v("\n        " + _vm._s(_vm.treatmentById(scope.row.treatmentId)) + "\n      ")]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "right",
      "label": "Onset Date",
      "prop": "onSetDate",
      "sortable": "",
      "width": "140"
    },
    scopedSlots: {
      default: function(scope) {
        return [_vm._v("\n        " + _vm._s(_vm._f("moment")(scope.row.onSetDate, 'DD-MM-YYYY')) + "\n      ")]
      }
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6a395574!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/Splash.vue
// module id = 247
// module chunks = 2